<template>
    <div>
        <div class="row">
            <div class="small-12 columns">
                <h2>Ihr Schreiben wurde an die Fluglinie gesendet!</h2>
                <p>
                    Sie erhalten eine Kopie sowie weitere Informationen per E-Mail.
                </p>
                <p>
                    Nun hat die Fluglinie zwei Wochen Zeit die Entschädigung an Sie zu
                    überweisen. Sie erhalten daher in zwei Wochen eine Erinnerungs-E-Mail
                    von uns. Wenn die Fluglinie bis dahin nicht reagiert hat, erhalten Sie
                    darin die Informationen zu den weiteren Schritte.
                </p>
                <p>
                    <strong>WICHTIGER HINWEIS:</strong> Oft antworten die
                    Fluggesellschaften mit der Aufforderung, Ihre Ansprüche über die
                    Website der Fluggesellschaft geltend zu machen. Sie müssen auf diese
                    Nachricht nicht reagieren. Der Fluggesellschaft liegen bereits alle
                    Informationen vor, die sie zur Bearbeitung Ihrer Angelegenheit
                    benötigt.
                </p>
                <p>
                    Übrigens:
                    <strong>Kennen Sie schon unser Angebot zum Widerruf Ihrer unrentablen Lebensversicherung?</strong>
                    Damit sparen Sie Geld und bekommen Ihre Beiträge plus Zinsen zurück.
                    Mehr unter
                    <strong>
                        <a href="https://ratis.de/lebensversicherung-widerruf/?pk_campaign=lv-cross&pk_source=fv-remind-mail">
                            ratis.de/lebensversicherung-widerruf
                        </a>
                    </strong>.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
};
</script>

<style></style>
